import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "kt_sidebar_content",
  class: "py-10 px-7 px-lg-12"
}
const _hoisted_2 = {
  class: "hover-scroll-y me-lg-n7 pe-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "10px",
  "data-kt-scroll-wrappers": "#kt_sidebar_content"
}
const _hoisted_3 = { id: "kt_sidebar_ai_tool_new_form" }
const _hoisted_4 = { class: "d-flex flex-column text-left rounded pb-6 px-2 mb-3" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  class: "mt-9 pb-12",
  style: {"max-height":"59vh !important"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 fw-bolder fs-6" }, null, -1)
const _hoisted_9 = ["id"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = ["data-placeholder"]
const _hoisted_14 = ["value", "innerHTML"]
const _hoisted_15 = { class: "text-center py-6 mb-10 pb-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary fw-bolder me-2 px-8 col-12"
}, " Adicionar ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", {
            class: "fs-1 fw-bolder mb-2",
            innerHTML: _ctx.page.metadata.title
          }, null, 8, _hoisted_5),
          _createElementVNode("span", {
            class: "fs-3",
            style: {"word-wrap":"break-word"},
            innerHTML: _ctx.page.metadata.description
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", {
          class: "bgi-no-repeat bgi-position-center bgi-size-cover h-80px h-lg-80px mw-100 w-650px mx-auto",
          style: _normalizeStyle(`background-image: url('${_ctx.page.banner}')`)
        }, null, 4),
        _createElementVNode("form", {
          class: "form mx-2",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.newProductFormSubmit && _ctx.newProductFormSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.page.metadata.fields, (field) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: field.id
              }, [
                (field.enabled)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "mb-8",
                      id: field.id
                    }, [
                      _createElementVNode("label", {
                        class: "fs-3 fw-bolder mb-1",
                        innerHTML: field.label
                      }, null, 8, _hoisted_10),
                      (field.type === 'text')
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "text",
                            class: "form-control form-control-solid form-control-lg",
                            placeholder: field.placeholder
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      (field.type === 'text_area')
                        ? (_openBlock(), _createElementBlock("textarea", {
                            key: 1,
                            placeholder: field.placeholder,
                            class: "form-control form-control-solid form-control-lg",
                            rows: "3"
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true),
                      (field.type === 'select')
                        ? (_openBlock(), _createElementBlock("select", {
                            key: 2,
                            "data-placeholder": field.placeholder,
                            class: "form-select form-select-solid form-select-lg",
                            "data-control": "select2",
                            "data-hide-search": "true"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.values, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option.value,
                                value: option.value,
                                innerHTML: option.label
                              }, null, 8, _hoisted_14))
                            }), 128))
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("button", {
                type: "reset",
                id: "kt_sidebar_ai_tool_filter_form_btn",
                class: "btn btn-color-gray-600 btn-link fw-bolder px-8",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showProductFilterForm && _ctx.showProductFilterForm(...args)))
              }, " Limpar ")
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}